// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewMessage-errorMessage-qd6U_ {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/*************************Common Styles start******************************************/

.ViewMessage-btn-UXpSI {
	padding: 7px 21px;
	border-color: var(--primary-border);
	background: var(--primary-white-bg);
	color: var(--common-text-color);
	font-weight: bold;
	font-size: 14px;
	border-radius: 2px;
}

.ViewMessage-btnPrimary-ZuasY {
	border-color: var(--btn-primary-bg);
	background-color: var(--btn-primary-bg);
	color: var(--white-text);
	border-radius: 6px !important;
	padding: 10px 28px !important;
	font-size: 18px;
	font-weight: 500;
	-webkit-border-radius: 6px !important;
	-moz-border-radius: 6px !important;
	-ms-border-radius: 6px !important;
	-o-border-radius: 6px !important;
}

.ViewMessage-btnPrimary-ZuasY:hover,
.ViewMessage-btnPrimary-ZuasY:focus,
.ViewMessage-btnPrimary-ZuasY:active,
.ViewMessage-btnPrimary-ZuasY:active:hover,
.ViewMessage-btnPrimary-ZuasY:active:focus,
.ViewMessage-btnPrimary-ZuasY[disabled]:hover,
.ViewMessage-btnPrimary-ZuasY[disabled]:focus {
	border-color: var(--btn-primary-bg);
	background-color: var(--btn-primary-bg);
	color: var(--white-text);
	-webkit-box-shadow: unset !important;
	        box-shadow: unset !important;
}

.ViewMessage-btnPrimaryBorder-qsmXY {
	border-color: var(--btn-primary-bg);
	color: var(--btn-primary-bg);
	background-color: var(--primary-white-bg);
	border-radius: 6px !important;
	padding: 10px 28px !important;
	font-size: 18px;
	font-weight: 500;
	-webkit-border-radius: 6px !important;
	-moz-border-radius: 6px !important;
	-ms-border-radius: 6px !important;
	-o-border-radius: 6px !important;
}

.ViewMessage-btnPrimaryBorder-qsmXY:hover,
.ViewMessage-btnPrimaryBorder-qsmXY:focus,
.ViewMessage-btnPrimaryBorder-qsmXY:active,
.ViewMessage-btnPrimaryBorder-qsmXY:active:hover,
.ViewMessage-btnPrimaryBorder-qsmXY:active:focus {
	border-color: var(--btn-primary-bg);
	color: var(--btn-primary-bg);
	background-color: var(--primary-white-bg);
	-webkit-box-shadow: unset !important;
	        box-shadow: unset !important;
}

.ViewMessage-btnRadius-uBhQB {
	border-radius: 60px;
}

.ViewMessage-linkBtn-NcUzO {
	border-radius: 4px;
	padding: 9px 21px;
}

.ViewMessage-space1-IAIb3 {
	margin-bottom: 6px;
}

.ViewMessage-space2-xOEty {
	margin-bottom: 12px;
}

.ViewMessage-space3-GGnhJ {
	margin-bottom: 18px;
}

.ViewMessage-space4-LsssU {
	margin-bottom: 24px;
}

.ViewMessage-space5-WLoOz {
	margin-bottom: 36px;
}

.ViewMessage-space6-bFgEM {
	margin-bottom: 48px;
}

.ViewMessage-spaceTop1-BYJfd {
	margin-top: 6px;
}

.ViewMessage-spaceTop2-nMoJy {
	margin-top: 12px;
}

.ViewMessage-spaceTop3-JXdXB {
	margin-top: 18px;
}

.ViewMessage-spaceTop4-P9W8F {
	margin-top: 24px;
}

.ViewMessage-spaceTop5-BWiQj {
	margin-top: 36px;
}

.ViewMessage-spaceTop6-bKwYl {
	margin-top: 48px
}

.ViewMessage-noMargin-VFPXH {
	margin: 0px;
}

.ViewMessage-noPadding-w0U7c {
	padding: 0px;
}

.ViewMessage-noBorder-xX3_Z {
	border: 0px none !important;
}

.ViewMessage-viewMessageContainer-ytD9a {
	background: var(--primary-white-bg);
	border: 1px solid var(--primary-border);
	border-radius: 12px;
	padding: 24px;
}

.ViewMessage-viewMessageContainerMobile-CXkZp {
	display: none;
}

/*************************Common Styles end******************************************/

/*************************Sidenavigation Styles start******************************************/

.ViewMessage-sidebarDesign-ksVav {
	padding: 50px 0 30px;
	background: var(--primary-white-bg);
	border-radius: 30px;
	-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;
	        box-shadow: 0 1px 15px 3px #eeebeb !important;
}

.ViewMessage-sidebarContainer-MQYxE {
	padding: 0 35px;
}

.ViewMessage-textCenter-xGfiz {
	text-align: center;
}

.ViewMessage-profileAvatarSection-YnpHB {
	position: relative;
	margin: 0 auto;
}

.ViewMessage-profileAvatarLink-JbY1f {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	overflow: hidden;
	background-color: var(--common-gray-bg-color);
	border-radius: 50%;
	border: 2px solid var(--primary-white-bg);
}

.ViewMessage-profileName-lQGzp {
	font-size: 18px;
	font-weight: bold;
	color: var(--common-text-color);
}

.ViewMessage-profileDetail-RmhC9 {
	font-size: 14px;
	color: var(--modalText-color);
}

.ViewMessage-horizontalLine-MU77P {
	margin-top: 15px;
	margin-bottom: 15px;
	border: 0;
	border-top: 1px solid var(--primary-border);
}

.ViewMessage-textGray-kvrP_ {
	color: var(--modalText-color);
}

.ViewMessage-textBold-MPjjr {
	font-weight: bold;
}

.ViewMessage-textLeft-JHA8n {
	text-align: left;
}

.ViewMessage-textRight-nJUVX {
	text-align: right;
}

.ViewMessage-link-vFfWf {
	text-decoration: none !important;
	cursor: pointer;
}

@media screen and (max-width: 768px) {
	.ViewMessage-hideSm-Fc3ir {
		display: none;
	}
}

@media screen and (max-width: 640px) {
	.ViewMessage-sidebarContainer-MQYxE {
		padding: 0 25px;
	}
}

/*************************Sidenavigation Styles End******************************************/

/*************************Message Styles start******************************************/

.ViewMessage-contextPadding-PKgP_ {
	padding-top: 8px;
	padding-bottom: 14px;
	border-radius: 0px;
	border: none;
	border-radius: 30px;
	padding-left: 15px;
	padding-right: 15px;
	-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;
	        box-shadow: 0 1px 15px 3px #eeebeb !important;
}

.ViewMessage-rowCondensed-_zS5a {
	margin-left: -6px;
	margin-right: -6px;
}

.ViewMessage-textBody-sSpow {
	margin: 0;
	text-align: left;
	position: relative;
}

.ViewMessage-bottomButton-X0ib6 {
	text-align: right;
	margin-top: 25px;
}

.ViewMessage-textBox-YzHS5 {
	min-height: 200px !important;
	border: 0px;
	margin-top: 0;
	-webkit-box-shadow: none;
	        box-shadow: none;
	padding: 15px;
	-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;
	        box-shadow: 0 1px 15px 3px #eeebeb !important;
	-webkit-appearance: none;
}

.ViewMessage-btnRight-m9LgW {
	margin-left: 10px;
}

.ViewMessage-panelDark-c6kaS {
	background-color: var(--common-gray-bg-color);
	margin: 0;
}

.ViewMessage-timeText-vvxwy {
	color: var(--modalText-color);
}

.ViewMessage-timeText-vvxwy:hover,
.ViewMessage-timeText-vvxwy:focus {
	color: var(--modalText-color);
	text-decoration: none;
	outline: none;
}

/*************************Chat bubble Right & Left Styles start******************************************/

.ViewMessage-panelQuote-gE5KC {
	margin-left: 0;
	margin-right: 0;
	position: relative;
	border-radius: 0px;
}

.ViewMessage-panelBubble-WSPGO {
	display: block;
	position: relative;
	height: auto;
	border-radius: 0;
	border: none;
	background: var(--primary-white-bg);
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
}

.ViewMessage-panelText-gfVAg {
	word-break: break-all !important;
}

/*************************Chat bubble Right & Left Styles end******************************************/

/*************************Notification Message Styles start******************************************/

.ViewMessage-inlineStatus-HSVGK {
	text-transform: uppercase;
}

.ViewMessage-horizontalText-cC8Kr {
	overflow: hidden;
	text-align: center;
}

.ViewMessage-textWrapper-LAg_d {
	position: relative;
	background: var(--primary-white-bg);
	display: inline-block;
}

.ViewMessage-textWrapper-LAg_d::before {
	content: "";
	position: absolute;
	border-bottom: 1px solid var(--primary-border);
	width: 500px;
	top: 50%;
	right: 100%;
	margin-right: 15px;
}

.ViewMessage-textWrapper-LAg_d::after {
	content: "";
	position: absolute;
	border-bottom: 1px solid var(--primary-border);
	width: 500px;
	top: 50%;
	left: 100%;
	margin-left: 15px;
}

/*************************Notification Message Styles end******************************************/

.ViewMessage-horizondalLine-ZncGa {
	margin-top: 18px;
	margin-bottom: 18px;
	border: 0;
	border-top: 1px solid var(--primary-border);
}

.ViewMessage-textLeft-JHA8n {
	text-align: left;
}

.ViewMessage-textRight-nJUVX {
	text-align: right;
}

.ViewMessage-textGray-kvrP_ {
	color: var(--modalText-color);
	font-size: 14px;
}

.ViewMessage-chevronIcon-Dbvm9 {
	font-size: 1.5em;
	margin-top: 10px;
	font-weight: normal;
	font-style: normal;
}

.ViewMessage-timerIcon-XVOBb {
	font-size: 1.5em;
	font-weight: normal;
	font-style: normal;
}

.ViewMessage-checkInDate-sN1Q4 {
	font-size: 14px;
	color: var(--common-text-color);
}

.ViewMessage-pullLeft-v6Sg0 {
	float: left;
}

.ViewMessage-pullRight-lhseh {
	float: right;
}

/** Discount **/

a,
a:hover,
a:focus,
a:active {
	text-decoration: none;
}

.ViewMessage-paddingRight-PNRo8 {
	padding: 0 0 0 35px;
}

.ViewMessage-displayTable-IENsR {
	width: 100%;
	display: table;
}

.ViewMessage-displayTableRow-Ghwre {
	width: 100%;
	display: table-row;
}

.ViewMessage-displayTableCell-tGyHw {
	display: table-cell;
	vertical-align: top;
}

.ViewMessage-displayTableWidth-h4VNN {
	width: 100%;
	position: relative;
}

.ViewMessage-profileAvatarSection-YnpHB {
	margin: 0 0 0 6px;
	position: relative;
	z-index: 5;
}

.ViewMessage-displayTableCellTop-rqz6z {
	display: table-cell;
	vertical-align: top;
}

.ViewMessage-profileAvatarSectionLeft-YdIba {
	position: relative;
	z-index: 5;
	margin: 0px 6px 0 0px;
}

.ViewMessage-guestHost-H9rdj {
	text-align: center;
	margin-bottom: 25px;
	background: var(--primary-white-bg);
	padding: 10px 0;
	padding: 18px 18px;
	border-radius: 30px;
	-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;
	        box-shadow: 0 1px 15px 3px #eeebeb !important;
}

.ViewMessage-hostChat-d8xxH {
	display: inline-block;
	vertical-align: middle;
}

.ViewMessage-hostChat-d8xxH img {
	width: 100%;
	border-radius: 50%;
	border: 2px solid var(--primary-white-bg);
	height: 100%;
	max-width: 100px;
	max-height: 100px;
	min-height: 100px;
}

.ViewMessage-centerChatIcon-vQCgS {
	height: 45px;
	width: 45px;
	margin-left: -20px;
	margin-right: -20px;
	position: relative;
	z-index: 2;
	text-align: center;
	display: inline-block;
	vertical-align: middle;
}

.ViewMessage-iconBG-XOOHj {
	border-radius: 50%;
	border: 2px solid var(--primary-border);
	border-width: 2px !important;
	background-color: var(--primary-white-bg);
	text-align: center;
	height: 45px;
	width: 45px;
}

.ViewMessage-iconBG-XOOHj img {
	width: 65%;
	display: inline-block;
	padding: 9px 0 0 0
}

.ViewMessage-hostName-aA309 {
	display: inline-block;
	vertical-align: middle;
	background: var(--primary-white-bg);
	padding: 10px;
	color: var(--common-text-color);
	font-size: 15px;
	width: 20%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.ViewMessage-linkColor-H6Z0u {
	display: block;
	color: var(--common-link-color) !important;
}

.ViewMessage-linkInline-ff8Sd {
	display: inline-block;
}

@media (max-width: 1023px) and (min-width: 768px) {
	.ViewMessage-noPaddingRight-HhJpc {
		padding-right: 0;
	}

	.ViewMessage-hostChat-d8xxH img {
		width: 100%;
		max-width: 80px;
		min-height: 80px;
		max-height: 80px;
	}

	.ViewMessage-iconBG-XOOHj img {
		padding: 8px 0 0 0;
	}

	.ViewMessage-iconBG-XOOHj {
		height: 40px;
		width: 40px;
	}

	.ViewMessage-centerChatIcon-vQCgS {
		height: 40px;
		width: 40px;
	}

	.ViewMessage-hostName-aA309 {
		width: 25%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
}

@media (max-width: 767px) {
	.ViewMessage-paddingRight-PNRo8 {
		padding: 0 0 0 0;
	}

	.ViewMessage-panelBubbleRight-H8nLV::before {
		display: none;
	}

	.ViewMessage-panelBubbleLeft-dOsS2::before {
		display: none;
	}

	.ViewMessage-panelBubbleRight-H8nLV::after {
		display: none;
	}

	.ViewMessage-panelBubbleLeft-dOsS2::after {
		display: none;
	}

	.ViewMessage-profileAvatarLink-JbY1f img {
		width: 60px;
		height: 60px;
	}

	.ViewMessage-profileAvatarSection-YnpHB {
		margin: 0 0 0 13px;
	}

	.ViewMessage-displayTableWidth-h4VNN {
		width: 100%;
	}

	.ViewMessage-displayTableWidthTwo-um83u {
		width: 20%;
	}

	.ViewMessage-profileAvatarSectionLeft-YdIba {
		margin: 0 10px 0 0;
		position: relative;
		z-index: 5;
	}

	.ViewMessage-radiusColor-sRFF0::after {
		display: none;
	}

	.ViewMessage-radiusColorTwo-YXesC::after {
		display: none;
	}

	.ViewMessage-displayTableCell-tGyHw {
		display: table-cell;
		vertical-align: middle;
	}

	.ViewMessage-viewMessageContainerWeb-bT6HM {
		display: none;
	}

	.ViewMessage-viewMessageContainerMobile-CXkZp {
		display: block !important;
	}
}

@media (max-width: 320px) {
	.ViewMessage-noPaddingRight-HhJpc {
		padding-right: 0;
	}
}

.ViewMessage-instantIcon-iB4lT {
	margin-top: -4px;
}

.ViewMessage-positionR-H8D2Y {
	position: relative;
}

.ViewMessage-tripText-b9Ioz {
	display: inline-block;
	width: 45%;
	font-weight: 500;
	color: var(--common-text-color);
}

.ViewMessage-tripTime-zeM36 {
	display: inline-block;
	width: 55%;
}

.ViewMessage-tripTitle-fWuLn {
	font-size: 18px;
	font-weight: 600;
}

.ViewMessage-tripBorderTop-mudY5 {
	padding-top: 6px;
	border-top: 1px solid var(--primary-border);
}

.ViewMessage-tripRadius-KEPhS {
	background: var(--primary-white-bg);
	border-radius: 30px;
}

.ViewMessage-tripBorderColor-CfyJQ {
	border: 1px solid var(--primary-border);
}

.ViewMessage-tripRadiusPadding-IkgTR {
	padding: 10px 10px 5px 10px;
}

.ViewMessage-tripSendMessage-ZTxqZ {
	border-radius: 0;
	border: 1px solid transparent;
	background: transparent;
	padding: 10px 0;
}

.ViewMessage-tripRadiusSent-jJeDj {
	background: transparent;
}

.ViewMessage-errorMessagePosition-xZmEE {
	position: absolute;
	bottom: -30px;
	left: 0;
	color: var(--alert-color);
}

@media (max-width: 991px) and (min-width: 768px) {
	.ViewMessage-sidebarContainer-MQYxE {
		padding: 0px 20px;
	}
}

@media screen and (max-width: 767px) {
	.ViewMessage-tripText-b9Ioz {
		width: 100%;
		text-align: center;
	}

	.ViewMessage-tripTime-zeM36 {
		width: 100%;
		text-align: center;
	}
}

/* message thread design start */

.ViewMessage-messageMainContainer-DGCUw {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
}

.ViewMessage-rsMessageContainer-_kktg,
.ViewMessage-rsFromMessageContainer-PXLzz,
.ViewMessage-lsSendMessageContainer-rrbjq {
	width: 100%;
	position: relative;
}

.ViewMessage-rsMessageContainer-_kktg {
	padding: 14px 35px 16px 16px;
	background: var(--dashBoard-info-bg);
	border-radius: 0 8px 8px 8px;
	-webkit-border-radius: 0 8px 8px 8px;
	-moz-border-radius: 0 8px 8px 8px;
	-ms-border-radius: 0 8px 8px 8px;
	-o-border-radius: 0 8px 8px 8px;
}

.ViewMessage-rsFromMessageContainer-PXLzz {
	padding: 12px 29px 16px 16px;
	background: var(--common-gray-bg-color);
	border-radius: 8px 0 8px 8px;
	-webkit-border-radius: 8px 0 8px 8px;
	-moz-border-radius: 8px 0 8px 8px;
	-ms-border-radius: 8px 0 8px 8px;
	-o-border-radius: 8px 0 8px 8px;
}

.ViewMessage-rsMessageContainer-_kktg::after,
.ViewMessage-rsFromMessageContainer-PXLzz::after,
.ViewMessage-lsSendMessageContainer-rrbjq::after {
	content: "";
	position: absolute;
	top: 0;
	width: 38px;
	height: 40px;
	background: var(--primary-white-bg);
	z-index: 3;
}

.ViewMessage-rsMessageContainer-_kktg::after {
	left: -38px;
	right: auto;
	border-top-right-radius: 30px;
	border-bottom-left-radius: 30px;
}

.ViewMessage-rsFromMessageContainer-PXLzz::after,
.ViewMessage-lsSendMessageContainer-rrbjq::after {
	right: -38px;
	left: auto;
	border-top-left-radius: 30px;
	border-bottom-right-radius: 30px;
}

.ViewMessage-rsMessageContainer-_kktg::before,
.ViewMessage-rsFromMessageContainer-PXLzz::before,
.ViewMessage-lsSendMessageContainer-rrbjq::before {
	content: " ";
	position: absolute;
	display: inline-block;
	width: 0;
	height: 0;
	bottom: auto;
	top: 0;
	border-style: solid;
}

.ViewMessage-rsMessageContainer-_kktg::before {
	left: auto;
	right: 100%;
	border-width: 0 24px 24px 0;
	border-color: transparent var(--dashBoard-info-bg) transparent transparent;
}

.ViewMessage-rsFromMessageContainer-PXLzz::before,
.ViewMessage-lsSendMessageContainer-rrbjq::before {
	right: auto;
	left: 100%;
	border-width: 24px 24px 0 0;
	border-color: var(--common-gray-bg-color) transparent transparent transparent;
}

.ViewMessage-messageText-OpqAE {
	font-size: 16px;
	font-weight: 400;
	color: var(--common-text-color);
}

.ViewMessage-messageText-OpqAE:hover,
.ViewMessage-messageText-OpqAE:focus {
	color: var(--common-text-color);
	text-decoration: none;
	outline: none;
}

.ViewMessage-dateText-AjI2I {
	font-size: 14px;
	font-weight: 400;
	color: var(--muted-text-color);
}

.ViewMessage-dateText-AjI2I:hover,
.ViewMessage-dateText-AjI2I:focus {
	color: var(--muted-text-color);
	text-decoration: none;
	outline: none;
}

.ViewMessage-messageAvatar-LrtOY {
	position: relative;
	z-index: 5;
}

.ViewMessage-commonProfileAvatarLink-I2pDR,
.ViewMessage-userDetailsImgContainer-oNkP3 {
	backface-visibility: hidden;
	position: relative;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	overflow: hidden;
	border-radius: 50%;
	border: 2px solid var(--common-link-color);
	background-color: transparent;
	padding: 3px;
	position: relative;
	z-index: 5;
	-webkit-backface-visibility: hidden;
}

.ViewMessage-commonProfileAvatarLink-I2pDR {
	width: 48px;
	height: 48px;
}

.ViewMessage-userDetailsImgContainer-oNkP3 {
	width: 58px;
	height: 58px;
}

.ViewMessage-commonProfileAvatarLink-I2pDR img,
.ViewMessage-sendMessageBtnContainer-mkeNg img,
.ViewMessage-userDetailsImgContainer-oNkP3 img {
	width: 100%;
	height: 100%;
	-o-object-fit: contain;
	   object-fit: contain;
	margin: 0;
	border-radius: 50%;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	-ms-border-radius: 50%;
	-o-border-radius: 50%;
}

.ViewMessage-commonProfileAvatarLink-I2pDR img,
.ViewMessage-sendMessageBtnContainer-mkeNg img {
	border-radius: 50%;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	-ms-border-radius: 50%;
	-o-border-radius: 50%;
}

.ViewMessage-marginLeft-AS7mh {
	margin-left: 6px;
}

.ViewMessage-statusText-rdQM4 {
	font-size: 16px;
	font-weight: 400;
	color: var(--common-text-color);
}

.ViewMessage-rsFromMessageMarginRight-u5RgX {
	margin-right: 6px;
}

.ViewMessage-sendMessageBtnContainer-mkeNg {
	background-color: unset;
	outline: unset;
	border: unset;
	color: transparent;
	backface-visibility: hidden;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	overflow: hidden;
	padding: 0;
	position: relative;
	z-index: 5;
	-webkit-backface-visibility: hidden;
	width: 48px;
	height: 48px;
	border-radius: 50%;
	-webkit-box-shadow: 0px 3px 6px #00000029;
	        box-shadow: 0px 3px 6px #00000029;
}

.ViewMessage-sendMessageBtnContainer-mkeNg:hover,
.ViewMessage-sendMessageBtnContainer-mkeNg:focus,
.ViewMessage-sendMessageBtnContainer-mkeNg:active,
.ViewMessage-sendMessageBtnContainer-mkeNg:active:hover,
.ViewMessage-sendMessageBtnContainer-mkeNg:focus:hover {
	border-color: transparent !important;
	background-color: transparent !important;
	-webkit-box-shadow: 0px 3px 6px #00000029;
	        box-shadow: 0px 3px 6px #00000029;
}

.ViewMessage-sendMessageErrorMessagePosition-Z2sOk {
	margin: 5px 0px;
	display: block;
	color: var(--alert-color);
	font-size: 14px;
	font-weight: normal;
}

.ViewMessage-sendTextBox-cKtJr {
	background: var(--common-gray-bg-color);
	border-radius: 8px 0 8px 8px;
	-webkit-border-radius: 8px 0 8px 8px;
	resize: unset;
	border: unset;
	outline: unset;
	-webkit-box-shadow: unset;
	        box-shadow: unset;
	height: 77px !important;
	padding: 14px 19px;
}

.ViewMessage-detailsContainer-Tevt_ {
	background: var(--common-gray-bg-color);
	border: 1px solid var(--primary-border);
	border-radius: 12px;
	padding: 24px;
}

.ViewMessage-userDetailsMarginLeft-evAmh {
	margin-left: 12px;
}

.ViewMessage-ownedByText-SDm18,
.ViewMessage-userDetailsName-fb_tY,
.ViewMessage-userDetailsName-fb_tY:hover,
.ViewMessage-userDetailsName-fb_tY:focus {
	font-size: 18px;
	font-weight: 600;
}

.ViewMessage-userDetailsName-fb_tY,
.ViewMessage-userDetailsName-fb_tY:hover,
.ViewMessage-userDetailsName-fb_tY:focus {
	color: var(--common-link-color);
}

.ViewMessage-ownedByText-SDm18 {
	color: var(--common-text-color);
}

.ViewMessage-marginLeft-AS7mh {
	margin-left: 6px;
}

.ViewMessage-borderBottom-y5foX {
	border-bottom: 1px solid var(--primary-border);
}

.ViewMessage-spacePaddingBottom4-K90lX {
	padding-bottom: 24px;
}

.ViewMessage-verificationFlexBox-gH9Aq,
.ViewMessage-verificationFlexContainer-uvBVM {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
}

.ViewMessage-verificationFlexContainer-uvBVM {
	margin-top: 8px;
}

.ViewMessage-dotCss-CnosO {
	width: 4px;
	height: 4px;
	background: var(--common-text-color);
	background: var(--common-background-color);
	border-radius: 50%;
	margin: 0px 7px;
	display: inline-block;
	position: relative;
}

.ViewMessage-verificationText-HgiSi,
.ViewMessage-verificationText-HgiSi:hover,
.ViewMessage-verificationText-HgiSi:focus {
	font-size: 16px;
	font-weight: 400;
	color: var(--common-text-color);
}

.ViewMessage-tripDetails-lAnts {
	font-size: 24px;
	font-weight: 600;
	color: var(--common-text-color);
}

.ViewMessage-marginBottom10-NNFc6 {
	margin-bottom: 10px;
}

.ViewMessage-displayGridDate-MJx5w {
	display: grid;
	grid-template-columns: 36% 15% 36%;
	gap: 15px;
}

.ViewMessage-checkInText-eZnD6 {
	font-size: 18px;
	font-weight: 600;
	color: var(--common-text-color);
}

.ViewMessage-marginTop0-VXzW1 {
	margin-top: 0;
}

.ViewMessage-marginBottom0-giBTp {
	margin-bottom: 0;
}

.ViewMessage-checkInDt-OzdhX {
	font-size: 16px;
	font-weight: 400;
	color: var(--common-text-color);
}

.ViewMessage-justifySelf-sSIUc {
	justify-self: center;
}

.ViewMessage-lsBillingText-ffwZs {
	-ms-flex-preferred-size: 55%;
	    flex-basis: 55%;
	width: 55%;
}

.ViewMessage-rsBillingText-PkQC4 {
	-ms-flex-preferred-size: 45%;
	    flex-basis: 45%;
	width: 45%;
}

.ViewMessage-billingTextContainer-Sd_9Q {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.ViewMessage-billingLine-uAQSo {
	margin-top: 12px;
	margin-bottom: 12px;
	border: 0;
	border-top: 1px solid var(--primary-border);
}

.ViewMessage-visibleXs-F36kA {
	display: block;
}

.ViewMessage-actionContainer-ARHak {
	background: #F4FFF0;
	border: 1px solid var(--primary-border);
	border-radius: 12px;
}

.ViewMessage-actionInnerBox-ZVU8g {
	padding: 24px;
}

.ViewMessage-noMarginTop-DXgwH {
	margin-top: 0;
}

.ViewMessage-actionHeading-TU2ZG {
	font-size: 24px;
	font-weight: 600;
}

.ViewMessage-actionPara-q1KV7 {
	font-size: 16px;
	font-weight: 400;
	color: var(--common-text-color)
}

.ViewMessage-timeIconColor-l2rDA {
	color: var(--common-text-color)
}

.ViewMessage-cancelDetailsContainer-ytOra .ViewMessage-cancelDetailsItems-HTNDx:nth-child(2) .ViewMessage-billingLine-uAQSo {
	display: none;
}

.ViewMessage-linkBgColor-M0v4P {
	font-size: 18px;
	font-weight: 400;
	color: var(--common-link-color) !important;
	display: inline-block;
}

.ViewMessage-verificationStarIcon-KxOkp {
	width: 16px;
	height: 15px;
}

.ViewMessage-verificationBotAlignment-sk3lE .ViewMessage-dotCss-CnosO {
	position: relative;
	top: 1px;
}

.ViewMessage-faqImage-x1oWA {
	width: 100%;
	max-width: 19px;
	vertical-align: middle;
	margin-right: 5px;
	position: relative;
	top: -2px;
}

/* message thread design end */

/* media queries start */

@media (min-width: 768px) {
	.ViewMessage-actionBlockContainer-BNk9t {
		display: none;
	}
}

@media (max-width: 767.98px) {

	.ViewMessage-ownedByText-SDm18,
	.ViewMessage-userDetailsName-fb_tY,
	.ViewMessage-userDetailsName-fb_tY:hover,
	.ViewMessage-userDetailsName-fb_tY:focus,
	.ViewMessage-tripTitle-fWuLn,
	.ViewMessage-checkInText-eZnD6 {
		font-size: 17px;
	}

	.ViewMessage-tripDetails-lAnts {
		font-size: 22px;
	}

	.ViewMessage-checkInDt-OzdhX,
	.ViewMessage-verificationText-HgiSi,
	.ViewMessage-verificationText-HgiSi:hover,
	.ViewMessage-verificationText-HgiSi:focus {
		font-size: 15px;
	}

	.ViewMessage-btnPrimary-ZuasY,
	.ViewMessage-btnPrimaryBorder-qsmXY {
		font-size: 16px;
		padding: 8px 20px !important;
	}

	.ViewMessage-btnPrimary-ZuasY:hover,
	.ViewMessage-btnPrimary-ZuasY:focus,
	.ViewMessage-btnPrimary-ZuasY:active,
	.ViewMessage-btnPrimary-ZuasY:active:hover,
	.ViewMessage-btnPrimary-ZuasY:active:focus,
	.ViewMessage-btnPrimaryBorder-qsmXY:hover,
	.ViewMessage-btnPrimaryBorder-qsmXY:focus,
	.ViewMessage-btnPrimaryBorder-qsmXY:active,
	.ViewMessage-btnPrimaryBorder-qsmXY:active:hover,
	.ViewMessage-btnPrimaryBorder-qsmXY:active:focus {
		font-size: 16px;
		padding: 8px 20px !important;
	}
}

@media (max-width: 785px) {
	.ViewMessage-verificationFlexContainer-uvBVM {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
		-webkit-box-align: start;
		    -ms-flex-align: start;
		        align-items: flex-start;
	}

	.ViewMessage-dotCss-CnosO {
		display: none;
	}

	.ViewMessage-marginTop6Mobile-V9n_w {
		margin-top: 6px;
	}
}

/* media queries end */`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/ViewMessage/ViewMessage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACNA,uFAAuF;;AAEvF;CACC,iBAAiB;CACjB,mCAAmC;CACnC,mCAAmC;CACnC,+BAA+B;CAC/B,iBAAiB;CACjB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,mCAAmC;CACnC,uCAAuC;CACvC,wBAAwB;CACxB,6BAA6B;CAC7B,6BAA6B;CAC7B,eAAe;CACf,gBAAgB;CAChB,qCAAqC;CACrC,kCAAkC;CAClC,iCAAiC;CACjC,gCAAgC;AACjC;;AAGA;;;;;;;CAOC,mCAAmC;CACnC,uCAAuC;CACvC,wBAAwB;CACxB,oCAA4B;SAA5B,4BAA4B;AAC7B;;AAEA;CACC,mCAAmC;CACnC,4BAA4B;CAC5B,yCAAyC;CACzC,6BAA6B;CAC7B,6BAA6B;CAC7B,eAAe;CACf,gBAAgB;CAChB,qCAAqC;CACrC,kCAAkC;CAClC,iCAAiC;CACjC,gCAAgC;AACjC;;AAEA;;;;;CAKC,mCAAmC;CACnC,4BAA4B;CAC5B,yCAAyC;CACzC,oCAA4B;SAA5B,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,mCAAmC;CACnC,uCAAuC;CACvC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA,qFAAqF;;AAErF,+FAA+F;;AAE/F;CACC,oBAAoB;CACpB,mCAAmC;CACnC,mBAAmB;CACnB,qDAA6C;SAA7C,6CAA6C;AAC9C;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,6CAA6C;CAC7C,kBAAkB;CAClB,yCAAyC;AAC1C;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,+BAA+B;AAChC;;AAEA;CACC,eAAe;CACf,6BAA6B;AAC9B;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,2CAA2C;AAC5C;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA,6FAA6F;;AAE7F,wFAAwF;;AACxF;CACC,gBAAgB;CAChB,oBAAoB;CACpB,kBAAkB;CAClB,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,qDAA6C;SAA7C,6CAA6C;AAC9C;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;CAC5B,WAAW;CACX,aAAa;CACb,wBAAgB;SAAhB,gBAAgB;CAChB,aAAa;CACb,qDAA6C;SAA7C,6CAA6C;CAC7C,wBAAwB;AACzB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,6CAA6C;CAC7C,SAAS;AACV;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;;CAEC,6BAA6B;CAC7B,qBAAqB;CACrB,aAAa;AACd;;AAEA,yGAAyG;;AACzG;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,YAAY;CACZ,mCAAmC;CACnC,mCAA2B;SAA3B,2BAA2B;AAC5B;;AAEA;CACC,gCAAgC;AACjC;;AAEA,uGAAuG;;AAEvG,qGAAqG;;AAErG;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mCAAmC;CACnC,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,8CAA8C;CAC9C,YAAY;CACZ,QAAQ;CACR,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,8CAA8C;CAC9C,YAAY;CACZ,QAAQ;CACR,UAAU;CACV,iBAAiB;AAClB;;AAEA,mGAAmG;;AAEnG;CACC,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,2CAA2C;AAC5C;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,6BAA6B;CAC7B,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,+BAA+B;AAChC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA,eAAe;;AAGf;;;;CAIC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,mCAAmC;CACnC,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,qDAA6C;SAA7C,6CAA6C;AAC9C;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,yCAAyC;CACzC,YAAY;CACZ,gBAAgB;CAChB,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,uCAAuC;CACvC,4BAA4B;CAC5B,yCAAyC;CACzC,kBAAkB;CAClB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;CACtB,mCAAmC;CACnC,aAAa;CACb,+BAA+B;CAC/B,eAAe;CACf,UAAU;CACV,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,0CAA0C;AAC3C;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;CACX;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,mBAAmB;EACnB,sBAAsB;CACvB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,2CAA2C;AAC5C;;AAEA;CACC,mCAAmC;CACnC,mBAAmB;AACpB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;CAChB,6BAA6B;CAC7B,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,OAAO;CACP,yBAAyB;AAC1B;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,gCAAgC;;AAChC;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;;;CAGC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;CAC5B,oCAAoC;CACpC,4BAA4B;CAC5B,oCAAoC;CACpC,iCAAiC;CACjC,gCAAgC;CAChC,+BAA+B;AAChC;;AAEA;CACC,4BAA4B;CAC5B,uCAAuC;CACvC,4BAA4B;CAC5B,oCAAoC;CACpC,iCAAiC;CACjC,gCAAgC;CAChC,+BAA+B;AAChC;;AAEA;;;CAGC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,YAAY;CACZ,mCAAmC;CACnC,UAAU;AACX;;AAEA;CACC,WAAW;CACX,WAAW;CACX,6BAA6B;CAC7B,+BAA+B;AAChC;;AAEA;;CAEC,YAAY;CACZ,UAAU;CACV,4BAA4B;CAC5B,gCAAgC;AACjC;;AAEA;;;CAGC,YAAY;CACZ,kBAAkB;CAClB,qBAAqB;CACrB,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,MAAM;CACN,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,2BAA2B;CAC3B,0EAA0E;AAC3E;;AAEA;;CAEC,WAAW;CACX,UAAU;CACV,2BAA2B;CAC3B,6EAA6E;AAC9E;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;;CAEC,+BAA+B;CAC/B,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,8BAA8B;AAC/B;;AAEA;;CAEC,8BAA8B;CAC9B,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;;CAEC,2BAA2B;CAC3B,kBAAkB;CAClB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;CAC1C,6BAA6B;CAC7B,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,mCAAmC;AACpC;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;;;CAGC,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;CACnB,SAAS;CACT,kBAAkB;CAClB,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;;CAEC,kBAAkB;CAClB,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;CACvB,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,2BAA2B;CAC3B,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAClB,UAAU;CACV,mCAAmC;CACnC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yCAAiC;SAAjC,iCAAiC;AAClC;;AAEA;;;;;CAKC,oCAAoC;CACpC,wCAAwC;CACxC,yCAAiC;SAAjC,iCAAiC;AAClC;;AAEA;CACC,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,uCAAuC;CACvC,4BAA4B;CAC5B,oCAAoC;CACpC,aAAa;CACb,aAAa;CACb,cAAc;CACd,yBAAiB;SAAjB,iBAAiB;CACjB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;CACvC,uCAAuC;CACvC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;;;CAIC,eAAe;CACf,gBAAgB;AACjB;;AAEA;;;CAGC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,oBAAoB;AACrB;;AAEA;;CAEC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,oCAAoC;CACpC,0CAA0C;CAC1C,kBAAkB;CAClB,eAAe;CACf,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;;;CAGC,eAAe;CACf,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,SAAS;AACV;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,4BAAe;KAAf,eAAe;CACf,UAAU;AACX;;AAEA;CACC,4BAAe;KAAf,eAAe;CACf,UAAU;AACX;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,uCAAuC;CACvC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,0CAA0C;CAC1C,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;CACtB,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;AACV;;AAEA,8BAA8B;;AAG9B,wBAAwB;;AAExB;CACC;EACC,aAAa;CACd;AACD;;AAEA;;CAEC;;;;;;EAMC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;;;;EAIC,eAAe;CAChB;;CAEA;;EAEC,eAAe;EACf,4BAA4B;CAC7B;;CAEA;;;;;;;;;;EAUC,eAAe;EACf,4BAA4B;CAC7B;AACD;;AAEA;CACC;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA,sBAAsB","sourcesContent":[".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../../components/utils.css';\n\n/*************************Common Styles start******************************************/\n\n.btn {\n\tpadding: 7px 21px;\n\tborder-color: var(--primary-border);\n\tbackground: var(--primary-white-bg);\n\tcolor: var(--common-text-color);\n\tfont-weight: bold;\n\tfont-size: 14px;\n\tborder-radius: 2px;\n}\n\n.btnPrimary {\n\tborder-color: var(--btn-primary-bg);\n\tbackground-color: var(--btn-primary-bg);\n\tcolor: var(--white-text);\n\tborder-radius: 6px !important;\n\tpadding: 10px 28px !important;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\t-webkit-border-radius: 6px !important;\n\t-moz-border-radius: 6px !important;\n\t-ms-border-radius: 6px !important;\n\t-o-border-radius: 6px !important;\n}\n\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus,\n.btnPrimary[disabled]:hover,\n.btnPrimary[disabled]:focus {\n\tborder-color: var(--btn-primary-bg);\n\tbackground-color: var(--btn-primary-bg);\n\tcolor: var(--white-text);\n\tbox-shadow: unset !important;\n}\n\n.btnPrimaryBorder {\n\tborder-color: var(--btn-primary-bg);\n\tcolor: var(--btn-primary-bg);\n\tbackground-color: var(--primary-white-bg);\n\tborder-radius: 6px !important;\n\tpadding: 10px 28px !important;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\t-webkit-border-radius: 6px !important;\n\t-moz-border-radius: 6px !important;\n\t-ms-border-radius: 6px !important;\n\t-o-border-radius: 6px !important;\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n\tborder-color: var(--btn-primary-bg);\n\tcolor: var(--btn-primary-bg);\n\tbackground-color: var(--primary-white-bg);\n\tbox-shadow: unset !important;\n}\n\n.btnRadius {\n\tborder-radius: 60px;\n}\n\n.linkBtn {\n\tborder-radius: 4px;\n\tpadding: 9px 21px;\n}\n\n.space1 {\n\tmargin-bottom: 6px;\n}\n\n.space2 {\n\tmargin-bottom: 12px;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.space4 {\n\tmargin-bottom: 24px;\n}\n\n.space5 {\n\tmargin-bottom: 36px;\n}\n\n.space6 {\n\tmargin-bottom: 48px;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px;\n}\n\n.spaceTop5 {\n\tmargin-top: 36px;\n}\n\n.spaceTop6 {\n\tmargin-top: 48px\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n.viewMessageContainer {\n\tbackground: var(--primary-white-bg);\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n\tpadding: 24px;\n}\n\n.viewMessageContainerMobile {\n\tdisplay: none;\n}\n\n/*************************Common Styles end******************************************/\n\n/*************************Sidenavigation Styles start******************************************/\n\n.sidebarDesign {\n\tpadding: 50px 0 30px;\n\tbackground: var(--primary-white-bg);\n\tborder-radius: 30px;\n\tbox-shadow: 0 1px 15px 3px #eeebeb !important;\n}\n\n.sidebarContainer {\n\tpadding: 0 35px;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.profileAvatarSection {\n\tposition: relative;\n\tmargin: 0 auto;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tbackground-color: var(--common-gray-bg-color);\n\tborder-radius: 50%;\n\tborder: 2px solid var(--primary-white-bg);\n}\n\n.profileName {\n\tfont-size: 18px;\n\tfont-weight: bold;\n\tcolor: var(--common-text-color);\n}\n\n.profileDetail {\n\tfont-size: 14px;\n\tcolor: var(--modalText-color);\n}\n\n.horizontalLine {\n\tmargin-top: 15px;\n\tmargin-bottom: 15px;\n\tborder: 0;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.textGray {\n\tcolor: var(--modalText-color);\n}\n\n.textBold {\n\tfont-weight: bold;\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.textRight {\n\ttext-align: right;\n}\n\n.link {\n\ttext-decoration: none !important;\n\tcursor: pointer;\n}\n\n@media screen and (max-width: 768px) {\n\t.hideSm {\n\t\tdisplay: none;\n\t}\n}\n\n@media screen and (max-width: 640px) {\n\t.sidebarContainer {\n\t\tpadding: 0 25px;\n\t}\n}\n\n/*************************Sidenavigation Styles End******************************************/\n\n/*************************Message Styles start******************************************/\n.contextPadding {\n\tpadding-top: 8px;\n\tpadding-bottom: 14px;\n\tborder-radius: 0px;\n\tborder: none;\n\tborder-radius: 30px;\n\tpadding-left: 15px;\n\tpadding-right: 15px;\n\tbox-shadow: 0 1px 15px 3px #eeebeb !important;\n}\n\n.rowCondensed {\n\tmargin-left: -6px;\n\tmargin-right: -6px;\n}\n\n.textBody {\n\tmargin: 0;\n\ttext-align: left;\n\tposition: relative;\n}\n\n.bottomButton {\n\ttext-align: right;\n\tmargin-top: 25px;\n}\n\n.textBox {\n\tmin-height: 200px !important;\n\tborder: 0px;\n\tmargin-top: 0;\n\tbox-shadow: none;\n\tpadding: 15px;\n\tbox-shadow: 0 1px 15px 3px #eeebeb !important;\n\t-webkit-appearance: none;\n}\n\n.btnRight {\n\tmargin-left: 10px;\n}\n\n.panelDark {\n\tbackground-color: var(--common-gray-bg-color);\n\tmargin: 0;\n}\n\n.timeText {\n\tcolor: var(--modalText-color);\n}\n\n.timeText:hover,\n.timeText:focus {\n\tcolor: var(--modalText-color);\n\ttext-decoration: none;\n\toutline: none;\n}\n\n/*************************Chat bubble Right & Left Styles start******************************************/\n.panelQuote {\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.panelBubble {\n\tdisplay: block;\n\tposition: relative;\n\theight: auto;\n\tborder-radius: 0;\n\tborder: none;\n\tbackground: var(--primary-white-bg);\n\tbox-shadow: none !important;\n}\n\n.panelText {\n\tword-break: break-all !important;\n}\n\n/*************************Chat bubble Right & Left Styles end******************************************/\n\n/*************************Notification Message Styles start******************************************/\n\n.inlineStatus {\n\ttext-transform: uppercase;\n}\n\n.horizontalText {\n\toverflow: hidden;\n\ttext-align: center;\n}\n\n.textWrapper {\n\tposition: relative;\n\tbackground: var(--primary-white-bg);\n\tdisplay: inline-block;\n}\n\n.textWrapper::before {\n\tcontent: \"\";\n\tposition: absolute;\n\tborder-bottom: 1px solid var(--primary-border);\n\twidth: 500px;\n\ttop: 50%;\n\tright: 100%;\n\tmargin-right: 15px;\n}\n\n.textWrapper::after {\n\tcontent: \"\";\n\tposition: absolute;\n\tborder-bottom: 1px solid var(--primary-border);\n\twidth: 500px;\n\ttop: 50%;\n\tleft: 100%;\n\tmargin-left: 15px;\n}\n\n/*************************Notification Message Styles end******************************************/\n\n.horizondalLine {\n\tmargin-top: 18px;\n\tmargin-bottom: 18px;\n\tborder: 0;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.textRight {\n\ttext-align: right;\n}\n\n.textGray {\n\tcolor: var(--modalText-color);\n\tfont-size: 14px;\n}\n\n.chevronIcon {\n\tfont-size: 1.5em;\n\tmargin-top: 10px;\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n.timerIcon {\n\tfont-size: 1.5em;\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n.checkInDate {\n\tfont-size: 14px;\n\tcolor: var(--common-text-color);\n}\n\n.pullLeft {\n\tfloat: left;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n/** Discount **/\n\n\na,\na:hover,\na:focus,\na:active {\n\ttext-decoration: none;\n}\n\n.paddingRight {\n\tpadding: 0 0 0 35px;\n}\n\n.displayTable {\n\twidth: 100%;\n\tdisplay: table;\n}\n\n.displayTableRow {\n\twidth: 100%;\n\tdisplay: table-row;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.displayTableWidth {\n\twidth: 100%;\n\tposition: relative;\n}\n\n.profileAvatarSection {\n\tmargin: 0 0 0 6px;\n\tposition: relative;\n\tz-index: 5;\n}\n\n.displayTableCellTop {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.profileAvatarSectionLeft {\n\tposition: relative;\n\tz-index: 5;\n\tmargin: 0px 6px 0 0px;\n}\n\n.guestHost {\n\ttext-align: center;\n\tmargin-bottom: 25px;\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px 0;\n\tpadding: 18px 18px;\n\tborder-radius: 30px;\n\tbox-shadow: 0 1px 15px 3px #eeebeb !important;\n}\n\n.hostChat {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.hostChat img {\n\twidth: 100%;\n\tborder-radius: 50%;\n\tborder: 2px solid var(--primary-white-bg);\n\theight: 100%;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tmin-height: 100px;\n}\n\n.centerChatIcon {\n\theight: 45px;\n\twidth: 45px;\n\tmargin-left: -20px;\n\tmargin-right: -20px;\n\tposition: relative;\n\tz-index: 2;\n\ttext-align: center;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.iconBG {\n\tborder-radius: 50%;\n\tborder: 2px solid var(--primary-border);\n\tborder-width: 2px !important;\n\tbackground-color: var(--primary-white-bg);\n\ttext-align: center;\n\theight: 45px;\n\twidth: 45px;\n}\n\n.iconBG img {\n\twidth: 65%;\n\tdisplay: inline-block;\n\tpadding: 9px 0 0 0\n}\n\n.hostName {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tcolor: var(--common-text-color);\n\tfont-size: 15px;\n\twidth: 20%;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\twhite-space: nowrap;\n}\n\n.linkColor {\n\tdisplay: block;\n\tcolor: var(--common-link-color) !important;\n}\n\n.linkInline {\n\tdisplay: inline-block;\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\t.noPaddingRight {\n\t\tpadding-right: 0;\n\t}\n\n\t.hostChat img {\n\t\twidth: 100%;\n\t\tmax-width: 80px;\n\t\tmin-height: 80px;\n\t\tmax-height: 80px;\n\t}\n\n\t.iconBG img {\n\t\tpadding: 8px 0 0 0;\n\t}\n\n\t.iconBG {\n\t\theight: 40px;\n\t\twidth: 40px;\n\t}\n\n\t.centerChatIcon {\n\t\theight: 40px;\n\t\twidth: 40px;\n\t}\n\n\t.hostName {\n\t\twidth: 25%;\n\t\ttext-overflow: ellipsis;\n\t\toverflow: hidden;\n\t\twhite-space: nowrap;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.paddingRight {\n\t\tpadding: 0 0 0 0;\n\t}\n\n\t.panelBubbleRight::before {\n\t\tdisplay: none;\n\t}\n\n\t.panelBubbleLeft::before {\n\t\tdisplay: none;\n\t}\n\n\t.panelBubbleRight::after {\n\t\tdisplay: none;\n\t}\n\n\t.panelBubbleLeft::after {\n\t\tdisplay: none;\n\t}\n\n\t.profileAvatarLink img {\n\t\twidth: 60px;\n\t\theight: 60px;\n\t}\n\n\t.profileAvatarSection {\n\t\tmargin: 0 0 0 13px;\n\t}\n\n\t.displayTableWidth {\n\t\twidth: 100%;\n\t}\n\n\t.displayTableWidthTwo {\n\t\twidth: 20%;\n\t}\n\n\t.profileAvatarSectionLeft {\n\t\tmargin: 0 10px 0 0;\n\t\tposition: relative;\n\t\tz-index: 5;\n\t}\n\n\t.radiusColor::after {\n\t\tdisplay: none;\n\t}\n\n\t.radiusColorTwo::after {\n\t\tdisplay: none;\n\t}\n\n\t.displayTableCell {\n\t\tdisplay: table-cell;\n\t\tvertical-align: middle;\n\t}\n\n\t.viewMessageContainerWeb {\n\t\tdisplay: none;\n\t}\n\n\t.viewMessageContainerMobile {\n\t\tdisplay: block !important;\n\t}\n}\n\n@media (max-width: 320px) {\n\t.noPaddingRight {\n\t\tpadding-right: 0;\n\t}\n}\n\n.instantIcon {\n\tmargin-top: -4px;\n}\n\n.positionR {\n\tposition: relative;\n}\n\n.tripText {\n\tdisplay: inline-block;\n\twidth: 45%;\n\tfont-weight: 500;\n\tcolor: var(--common-text-color);\n}\n\n.tripTime {\n\tdisplay: inline-block;\n\twidth: 55%;\n}\n\n.tripTitle {\n\tfont-size: 18px;\n\tfont-weight: 600;\n}\n\n.tripBorderTop {\n\tpadding-top: 6px;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.tripRadius {\n\tbackground: var(--primary-white-bg);\n\tborder-radius: 30px;\n}\n\n.tripBorderColor {\n\tborder: 1px solid var(--primary-border);\n}\n\n.tripRadiusPadding {\n\tpadding: 10px 10px 5px 10px;\n}\n\n.tripSendMessage {\n\tborder-radius: 0;\n\tborder: 1px solid transparent;\n\tbackground: transparent;\n\tpadding: 10px 0;\n}\n\n.tripRadiusSent {\n\tbackground: transparent;\n}\n\n.errorMessagePosition {\n\tposition: absolute;\n\tbottom: -30px;\n\tleft: 0;\n\tcolor: var(--alert-color);\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n\t.sidebarContainer {\n\t\tpadding: 0px 20px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.tripText {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.tripTime {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/* message thread design start */\n.messageMainContainer {\n\tdisplay: flex;\n\talign-items: flex-start;\n}\n\n.rsMessageContainer,\n.rsFromMessageContainer,\n.lsSendMessageContainer {\n\twidth: 100%;\n\tposition: relative;\n}\n\n.rsMessageContainer {\n\tpadding: 14px 35px 16px 16px;\n\tbackground: var(--dashBoard-info-bg);\n\tborder-radius: 0 8px 8px 8px;\n\t-webkit-border-radius: 0 8px 8px 8px;\n\t-moz-border-radius: 0 8px 8px 8px;\n\t-ms-border-radius: 0 8px 8px 8px;\n\t-o-border-radius: 0 8px 8px 8px;\n}\n\n.rsFromMessageContainer {\n\tpadding: 12px 29px 16px 16px;\n\tbackground: var(--common-gray-bg-color);\n\tborder-radius: 8px 0 8px 8px;\n\t-webkit-border-radius: 8px 0 8px 8px;\n\t-moz-border-radius: 8px 0 8px 8px;\n\t-ms-border-radius: 8px 0 8px 8px;\n\t-o-border-radius: 8px 0 8px 8px;\n}\n\n.rsMessageContainer::after,\n.rsFromMessageContainer::after,\n.lsSendMessageContainer::after {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 0;\n\twidth: 38px;\n\theight: 40px;\n\tbackground: var(--primary-white-bg);\n\tz-index: 3;\n}\n\n.rsMessageContainer::after {\n\tleft: -38px;\n\tright: auto;\n\tborder-top-right-radius: 30px;\n\tborder-bottom-left-radius: 30px;\n}\n\n.rsFromMessageContainer::after,\n.lsSendMessageContainer::after {\n\tright: -38px;\n\tleft: auto;\n\tborder-top-left-radius: 30px;\n\tborder-bottom-right-radius: 30px;\n}\n\n.rsMessageContainer::before,\n.rsFromMessageContainer::before,\n.lsSendMessageContainer::before {\n\tcontent: \" \";\n\tposition: absolute;\n\tdisplay: inline-block;\n\twidth: 0;\n\theight: 0;\n\tbottom: auto;\n\ttop: 0;\n\tborder-style: solid;\n}\n\n.rsMessageContainer::before {\n\tleft: auto;\n\tright: 100%;\n\tborder-width: 0 24px 24px 0;\n\tborder-color: transparent var(--dashBoard-info-bg) transparent transparent;\n}\n\n.rsFromMessageContainer::before,\n.lsSendMessageContainer::before {\n\tright: auto;\n\tleft: 100%;\n\tborder-width: 24px 24px 0 0;\n\tborder-color: var(--common-gray-bg-color) transparent transparent transparent;\n}\n\n.messageText {\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tcolor: var(--common-text-color);\n}\n\n.messageText:hover,\n.messageText:focus {\n\tcolor: var(--common-text-color);\n\ttext-decoration: none;\n\toutline: none;\n}\n\n.dateText {\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tcolor: var(--muted-text-color);\n}\n\n.dateText:hover,\n.dateText:focus {\n\tcolor: var(--muted-text-color);\n\ttext-decoration: none;\n\toutline: none;\n}\n\n.messageAvatar {\n\tposition: relative;\n\tz-index: 5;\n}\n\n.commonProfileAvatarLink,\n.userDetailsImgContainer {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tborder: 2px solid var(--common-link-color);\n\tbackground-color: transparent;\n\tpadding: 3px;\n\tposition: relative;\n\tz-index: 5;\n\t-webkit-backface-visibility: hidden;\n}\n\n.commonProfileAvatarLink {\n\twidth: 48px;\n\theight: 48px;\n}\n\n.userDetailsImgContainer {\n\twidth: 58px;\n\theight: 58px;\n}\n\n.commonProfileAvatarLink img,\n.sendMessageBtnContainer img,\n.userDetailsImgContainer img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: contain;\n\tmargin: 0;\n\tborder-radius: 50%;\n\t-webkit-border-radius: 50%;\n\t-moz-border-radius: 50%;\n\t-ms-border-radius: 50%;\n\t-o-border-radius: 50%;\n}\n\n.commonProfileAvatarLink img,\n.sendMessageBtnContainer img {\n\tborder-radius: 50%;\n\t-webkit-border-radius: 50%;\n\t-moz-border-radius: 50%;\n\t-ms-border-radius: 50%;\n\t-o-border-radius: 50%;\n}\n\n.marginLeft {\n\tmargin-left: 6px;\n}\n\n.statusText {\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tcolor: var(--common-text-color);\n}\n\n.rsFromMessageMarginRight {\n\tmargin-right: 6px;\n}\n\n.sendMessageBtnContainer {\n\tbackground-color: unset;\n\toutline: unset;\n\tborder: unset;\n\tcolor: transparent;\n\tbackface-visibility: hidden;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\toverflow: hidden;\n\tpadding: 0;\n\tposition: relative;\n\tz-index: 5;\n\t-webkit-backface-visibility: hidden;\n\twidth: 48px;\n\theight: 48px;\n\tborder-radius: 50%;\n\tbox-shadow: 0px 3px 6px #00000029;\n}\n\n.sendMessageBtnContainer:hover,\n.sendMessageBtnContainer:focus,\n.sendMessageBtnContainer:active,\n.sendMessageBtnContainer:active:hover,\n.sendMessageBtnContainer:focus:hover {\n\tborder-color: transparent !important;\n\tbackground-color: transparent !important;\n\tbox-shadow: 0px 3px 6px #00000029;\n}\n\n.sendMessageErrorMessagePosition {\n\tmargin: 5px 0px;\n\tdisplay: block;\n\tcolor: var(--alert-color);\n\tfont-size: 14px;\n\tfont-weight: normal;\n}\n\n.sendTextBox {\n\tbackground: var(--common-gray-bg-color);\n\tborder-radius: 8px 0 8px 8px;\n\t-webkit-border-radius: 8px 0 8px 8px;\n\tresize: unset;\n\tborder: unset;\n\toutline: unset;\n\tbox-shadow: unset;\n\theight: 77px !important;\n\tpadding: 14px 19px;\n}\n\n.detailsContainer {\n\tbackground: var(--common-gray-bg-color);\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n\tpadding: 24px;\n}\n\n.userDetailsMarginLeft {\n\tmargin-left: 12px;\n}\n\n.ownedByText,\n.userDetailsName,\n.userDetailsName:hover,\n.userDetailsName:focus {\n\tfont-size: 18px;\n\tfont-weight: 600;\n}\n\n.userDetailsName,\n.userDetailsName:hover,\n.userDetailsName:focus {\n\tcolor: var(--common-link-color);\n}\n\n.ownedByText {\n\tcolor: var(--common-text-color);\n}\n\n.marginLeft {\n\tmargin-left: 6px;\n}\n\n.borderBottom {\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.spacePaddingBottom4 {\n\tpadding-bottom: 24px;\n}\n\n.verificationFlexBox,\n.verificationFlexContainer {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n}\n\n.verificationFlexContainer {\n\tmargin-top: 8px;\n}\n\n.dotCss {\n\twidth: 4px;\n\theight: 4px;\n\tbackground: var(--common-text-color);\n\tbackground: var(--common-background-color);\n\tborder-radius: 50%;\n\tmargin: 0px 7px;\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\n.verificationText,\n.verificationText:hover,\n.verificationText:focus {\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tcolor: var(--common-text-color);\n}\n\n.tripDetails {\n\tfont-size: 24px;\n\tfont-weight: 600;\n\tcolor: var(--common-text-color);\n}\n\n.marginBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.displayGridDate {\n\tdisplay: grid;\n\tgrid-template-columns: 36% 15% 36%;\n\tgap: 15px;\n}\n\n.checkInText {\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tcolor: var(--common-text-color);\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.checkInDt {\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tcolor: var(--common-text-color);\n}\n\n.justifySelf {\n\tjustify-self: center;\n}\n\n.lsBillingText {\n\tflex-basis: 55%;\n\twidth: 55%;\n}\n\n.rsBillingText {\n\tflex-basis: 45%;\n\twidth: 45%;\n}\n\n.billingTextContainer {\n\tdisplay: flex;\n}\n\n.billingLine {\n\tmargin-top: 12px;\n\tmargin-bottom: 12px;\n\tborder: 0;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.visibleXs {\n\tdisplay: block;\n}\n\n.actionContainer {\n\tbackground: #F4FFF0;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n}\n\n.actionInnerBox {\n\tpadding: 24px;\n}\n\n.noMarginTop {\n\tmargin-top: 0;\n}\n\n.actionHeading {\n\tfont-size: 24px;\n\tfont-weight: 600;\n}\n\n.actionPara {\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tcolor: var(--common-text-color)\n}\n\n.timeIconColor {\n\tcolor: var(--common-text-color)\n}\n\n.cancelDetailsContainer .cancelDetailsItems:nth-child(2) .billingLine {\n\tdisplay: none;\n}\n\n.linkBgColor {\n\tfont-size: 18px;\n\tfont-weight: 400;\n\tcolor: var(--common-link-color) !important;\n\tdisplay: inline-block;\n}\n\n.verificationStarIcon {\n\twidth: 16px;\n\theight: 15px;\n}\n\n.verificationBotAlignment .dotCss {\n\tposition: relative;\n\ttop: 1px;\n}\n\n.faqImage {\n\twidth: 100%;\n\tmax-width: 19px;\n\tvertical-align: middle;\n\tmargin-right: 5px;\n\tposition: relative;\n\ttop: -2px;\n}\n\n/* message thread design end */\n\n\n/* media queries start */\n\n@media (min-width: 768px) {\n\t.actionBlockContainer {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 767.98px) {\n\n\t.ownedByText,\n\t.userDetailsName,\n\t.userDetailsName:hover,\n\t.userDetailsName:focus,\n\t.tripTitle,\n\t.checkInText {\n\t\tfont-size: 17px;\n\t}\n\n\t.tripDetails {\n\t\tfont-size: 22px;\n\t}\n\n\t.checkInDt,\n\t.verificationText,\n\t.verificationText:hover,\n\t.verificationText:focus {\n\t\tfont-size: 15px;\n\t}\n\n\t.btnPrimary,\n\t.btnPrimaryBorder {\n\t\tfont-size: 16px;\n\t\tpadding: 8px 20px !important;\n\t}\n\n\t.btnPrimary:hover,\n\t.btnPrimary:focus,\n\t.btnPrimary:active,\n\t.btnPrimary:active:hover,\n\t.btnPrimary:active:focus,\n\t.btnPrimaryBorder:hover,\n\t.btnPrimaryBorder:focus,\n\t.btnPrimaryBorder:active,\n\t.btnPrimaryBorder:active:hover,\n\t.btnPrimaryBorder:active:focus {\n\t\tfont-size: 16px;\n\t\tpadding: 8px 20px !important;\n\t}\n}\n\n@media (max-width: 785px) {\n\t.verificationFlexContainer {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t}\n\n\t.dotCss {\n\t\tdisplay: none;\n\t}\n\n\t.marginTop6Mobile {\n\t\tmargin-top: 6px;\n\t}\n}\n\n/* media queries end */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `ViewMessage-errorMessage-qd6U_`,
	"btn": `ViewMessage-btn-UXpSI`,
	"btnPrimary": `ViewMessage-btnPrimary-ZuasY`,
	"btnPrimaryBorder": `ViewMessage-btnPrimaryBorder-qsmXY`,
	"btnRadius": `ViewMessage-btnRadius-uBhQB`,
	"linkBtn": `ViewMessage-linkBtn-NcUzO`,
	"space1": `ViewMessage-space1-IAIb3`,
	"space2": `ViewMessage-space2-xOEty`,
	"space3": `ViewMessage-space3-GGnhJ`,
	"space4": `ViewMessage-space4-LsssU`,
	"space5": `ViewMessage-space5-WLoOz`,
	"space6": `ViewMessage-space6-bFgEM`,
	"spaceTop1": `ViewMessage-spaceTop1-BYJfd`,
	"spaceTop2": `ViewMessage-spaceTop2-nMoJy`,
	"spaceTop3": `ViewMessage-spaceTop3-JXdXB`,
	"spaceTop4": `ViewMessage-spaceTop4-P9W8F`,
	"spaceTop5": `ViewMessage-spaceTop5-BWiQj`,
	"spaceTop6": `ViewMessage-spaceTop6-bKwYl`,
	"noMargin": `ViewMessage-noMargin-VFPXH`,
	"noPadding": `ViewMessage-noPadding-w0U7c`,
	"noBorder": `ViewMessage-noBorder-xX3_Z`,
	"viewMessageContainer": `ViewMessage-viewMessageContainer-ytD9a`,
	"viewMessageContainerMobile": `ViewMessage-viewMessageContainerMobile-CXkZp`,
	"sidebarDesign": `ViewMessage-sidebarDesign-ksVav`,
	"sidebarContainer": `ViewMessage-sidebarContainer-MQYxE`,
	"textCenter": `ViewMessage-textCenter-xGfiz`,
	"profileAvatarSection": `ViewMessage-profileAvatarSection-YnpHB`,
	"profileAvatarLink": `ViewMessage-profileAvatarLink-JbY1f`,
	"profileName": `ViewMessage-profileName-lQGzp`,
	"profileDetail": `ViewMessage-profileDetail-RmhC9`,
	"horizontalLine": `ViewMessage-horizontalLine-MU77P`,
	"textGray": `ViewMessage-textGray-kvrP_`,
	"textBold": `ViewMessage-textBold-MPjjr`,
	"textLeft": `ViewMessage-textLeft-JHA8n`,
	"textRight": `ViewMessage-textRight-nJUVX`,
	"link": `ViewMessage-link-vFfWf`,
	"hideSm": `ViewMessage-hideSm-Fc3ir`,
	"contextPadding": `ViewMessage-contextPadding-PKgP_`,
	"rowCondensed": `ViewMessage-rowCondensed-_zS5a`,
	"textBody": `ViewMessage-textBody-sSpow`,
	"bottomButton": `ViewMessage-bottomButton-X0ib6`,
	"textBox": `ViewMessage-textBox-YzHS5`,
	"btnRight": `ViewMessage-btnRight-m9LgW`,
	"panelDark": `ViewMessage-panelDark-c6kaS`,
	"timeText": `ViewMessage-timeText-vvxwy`,
	"panelQuote": `ViewMessage-panelQuote-gE5KC`,
	"panelBubble": `ViewMessage-panelBubble-WSPGO`,
	"panelText": `ViewMessage-panelText-gfVAg`,
	"inlineStatus": `ViewMessage-inlineStatus-HSVGK`,
	"horizontalText": `ViewMessage-horizontalText-cC8Kr`,
	"textWrapper": `ViewMessage-textWrapper-LAg_d`,
	"horizondalLine": `ViewMessage-horizondalLine-ZncGa`,
	"chevronIcon": `ViewMessage-chevronIcon-Dbvm9`,
	"timerIcon": `ViewMessage-timerIcon-XVOBb`,
	"checkInDate": `ViewMessage-checkInDate-sN1Q4`,
	"pullLeft": `ViewMessage-pullLeft-v6Sg0`,
	"pullRight": `ViewMessage-pullRight-lhseh`,
	"paddingRight": `ViewMessage-paddingRight-PNRo8`,
	"displayTable": `ViewMessage-displayTable-IENsR`,
	"displayTableRow": `ViewMessage-displayTableRow-Ghwre`,
	"displayTableCell": `ViewMessage-displayTableCell-tGyHw`,
	"displayTableWidth": `ViewMessage-displayTableWidth-h4VNN`,
	"displayTableCellTop": `ViewMessage-displayTableCellTop-rqz6z`,
	"profileAvatarSectionLeft": `ViewMessage-profileAvatarSectionLeft-YdIba`,
	"guestHost": `ViewMessage-guestHost-H9rdj`,
	"hostChat": `ViewMessage-hostChat-d8xxH`,
	"centerChatIcon": `ViewMessage-centerChatIcon-vQCgS`,
	"iconBG": `ViewMessage-iconBG-XOOHj`,
	"hostName": `ViewMessage-hostName-aA309`,
	"linkColor": `ViewMessage-linkColor-H6Z0u`,
	"linkInline": `ViewMessage-linkInline-ff8Sd`,
	"noPaddingRight": `ViewMessage-noPaddingRight-HhJpc`,
	"panelBubbleRight": `ViewMessage-panelBubbleRight-H8nLV`,
	"panelBubbleLeft": `ViewMessage-panelBubbleLeft-dOsS2`,
	"displayTableWidthTwo": `ViewMessage-displayTableWidthTwo-um83u`,
	"radiusColor": `ViewMessage-radiusColor-sRFF0`,
	"radiusColorTwo": `ViewMessage-radiusColorTwo-YXesC`,
	"viewMessageContainerWeb": `ViewMessage-viewMessageContainerWeb-bT6HM`,
	"instantIcon": `ViewMessage-instantIcon-iB4lT`,
	"positionR": `ViewMessage-positionR-H8D2Y`,
	"tripText": `ViewMessage-tripText-b9Ioz`,
	"tripTime": `ViewMessage-tripTime-zeM36`,
	"tripTitle": `ViewMessage-tripTitle-fWuLn`,
	"tripBorderTop": `ViewMessage-tripBorderTop-mudY5`,
	"tripRadius": `ViewMessage-tripRadius-KEPhS`,
	"tripBorderColor": `ViewMessage-tripBorderColor-CfyJQ`,
	"tripRadiusPadding": `ViewMessage-tripRadiusPadding-IkgTR`,
	"tripSendMessage": `ViewMessage-tripSendMessage-ZTxqZ`,
	"tripRadiusSent": `ViewMessage-tripRadiusSent-jJeDj`,
	"errorMessagePosition": `ViewMessage-errorMessagePosition-xZmEE`,
	"messageMainContainer": `ViewMessage-messageMainContainer-DGCUw`,
	"rsMessageContainer": `ViewMessage-rsMessageContainer-_kktg`,
	"rsFromMessageContainer": `ViewMessage-rsFromMessageContainer-PXLzz`,
	"lsSendMessageContainer": `ViewMessage-lsSendMessageContainer-rrbjq`,
	"messageText": `ViewMessage-messageText-OpqAE`,
	"dateText": `ViewMessage-dateText-AjI2I`,
	"messageAvatar": `ViewMessage-messageAvatar-LrtOY`,
	"commonProfileAvatarLink": `ViewMessage-commonProfileAvatarLink-I2pDR`,
	"userDetailsImgContainer": `ViewMessage-userDetailsImgContainer-oNkP3`,
	"sendMessageBtnContainer": `ViewMessage-sendMessageBtnContainer-mkeNg`,
	"marginLeft": `ViewMessage-marginLeft-AS7mh`,
	"statusText": `ViewMessage-statusText-rdQM4`,
	"rsFromMessageMarginRight": `ViewMessage-rsFromMessageMarginRight-u5RgX`,
	"sendMessageErrorMessagePosition": `ViewMessage-sendMessageErrorMessagePosition-Z2sOk`,
	"sendTextBox": `ViewMessage-sendTextBox-cKtJr`,
	"detailsContainer": `ViewMessage-detailsContainer-Tevt_`,
	"userDetailsMarginLeft": `ViewMessage-userDetailsMarginLeft-evAmh`,
	"ownedByText": `ViewMessage-ownedByText-SDm18`,
	"userDetailsName": `ViewMessage-userDetailsName-fb_tY`,
	"borderBottom": `ViewMessage-borderBottom-y5foX`,
	"spacePaddingBottom4": `ViewMessage-spacePaddingBottom4-K90lX`,
	"verificationFlexBox": `ViewMessage-verificationFlexBox-gH9Aq`,
	"verificationFlexContainer": `ViewMessage-verificationFlexContainer-uvBVM`,
	"dotCss": `ViewMessage-dotCss-CnosO`,
	"verificationText": `ViewMessage-verificationText-HgiSi`,
	"tripDetails": `ViewMessage-tripDetails-lAnts`,
	"marginBottom10": `ViewMessage-marginBottom10-NNFc6`,
	"displayGridDate": `ViewMessage-displayGridDate-MJx5w`,
	"checkInText": `ViewMessage-checkInText-eZnD6`,
	"marginTop0": `ViewMessage-marginTop0-VXzW1`,
	"marginBottom0": `ViewMessage-marginBottom0-giBTp`,
	"checkInDt": `ViewMessage-checkInDt-OzdhX`,
	"justifySelf": `ViewMessage-justifySelf-sSIUc`,
	"lsBillingText": `ViewMessage-lsBillingText-ffwZs`,
	"rsBillingText": `ViewMessage-rsBillingText-PkQC4`,
	"billingTextContainer": `ViewMessage-billingTextContainer-Sd_9Q`,
	"billingLine": `ViewMessage-billingLine-uAQSo`,
	"visibleXs": `ViewMessage-visibleXs-F36kA`,
	"actionContainer": `ViewMessage-actionContainer-ARHak`,
	"actionInnerBox": `ViewMessage-actionInnerBox-ZVU8g`,
	"noMarginTop": `ViewMessage-noMarginTop-DXgwH`,
	"actionHeading": `ViewMessage-actionHeading-TU2ZG`,
	"actionPara": `ViewMessage-actionPara-q1KV7`,
	"timeIconColor": `ViewMessage-timeIconColor-l2rDA`,
	"cancelDetailsContainer": `ViewMessage-cancelDetailsContainer-ytOra`,
	"cancelDetailsItems": `ViewMessage-cancelDetailsItems-HTNDx`,
	"linkBgColor": `ViewMessage-linkBgColor-M0v4P`,
	"verificationStarIcon": `ViewMessage-verificationStarIcon-KxOkp`,
	"verificationBotAlignment": `ViewMessage-verificationBotAlignment-sk3lE`,
	"faqImage": `ViewMessage-faqImage-x1oWA`,
	"actionBlockContainer": `ViewMessage-actionBlockContainer-BNk9t`,
	"marginTop6Mobile": `ViewMessage-marginTop6Mobile-V9n_w`
};
module.exports = ___CSS_LOADER_EXPORT___;
